var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClothingRack(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.529 45.757L44.519 3.97A3.244 3.244 0 0041.274.727H8.715A3.244 3.244 0 005.47 3.951l-1.01 41.806H.791v1.516h8.822v-1.516H5.976L6.986 3.97a1.738 1.738 0 011.729-1.728h32.56a1.739 1.739 0 011.727 1.748l1.011 41.766h-3.638v1.516h8.832v-1.516H45.53z",
    fill: "#420022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.486 6.467V2.495H16.97v3.972l-4.982 4.658a.758.758 0 00.526 1.314h10.428a.758.758 0 00.516-1.314l-4.972-4.658zm-4.042 4.456l3.304-3.092 3.294 3.092h-6.598zM38.627 11.115l-4.971-4.658V2.485H32.14v3.972l-4.982 4.658a.859.859 0 00-.142.192v.071a1.282 1.282 0 000 .192l-1.01 22.02a.758.758 0 00.202.555.767.767 0 00.556.233h12.42a.75.75 0 00.707-.489.77.77 0 00.05-.3l-1.01-21.827a.749.749 0 00-.303-.647zm-5.73-3.294l3.295 3.092h-6.599l3.305-3.092zm-4.496 4.608h3.719v20.514H27.46l.94-20.514zm5.234 20.504V12.439h3.72l.939 20.504-4.659-.01z",
    fill: "#420022"
  })));
}
export default SvgClothingRack;